import { StateCreator } from 'zustand';
import { IApp } from '../types/IApp';

const createAppSlice: StateCreator<IApp> = set => ({
  isMobile: typeof window !== 'undefined' && window.innerWidth < 768,
  isPromoModalVisible: false,
  emailUsModalVisible: false,
  isGlobalEModalVisible: false,
  isAppointmentBookingModalVisible: false,
  chatOrigin: '',
  setEmailUsModalVisible(emailUsModalVisible: boolean) {
    set({ emailUsModalVisible });
  },
  setIsMobile(isMobile: boolean) {
    set({ isMobile });
  },
  setIsPromoModalVisible(isPromoModalVisible: boolean) {
    set({ isPromoModalVisible });
  },
  setIsAppointmentBookingModalVisible(isAppointmentBookingModalVisible: boolean) {
    set({ isAppointmentBookingModalVisible });
  },
  setChatOrigin(chatOrigin: string) {
    set({ chatOrigin });
  },
  setIsGlobalEModalVisible(isGlobalEModalVisible: boolean) {
    set({ isGlobalEModalVisible });
  },
});

export default createAppSlice;
